const ru = {
  translation: {
    language: { label: 'Язык интерфейса', ru: 'Русский', en: 'English', bg: 'Български' },
    navigation: {
      close: 'Закрыть',
      account: 'Личный кабинет',
      products: 'Продукты / Лицензии',
      finance: 'Мои финансы',
      calculator: 'Калькулятор',
      partners: 'Партнёру',
      events: 'Мероприятия',
      profile: 'Личные данные',
      support: 'Поддержка',
      promo: 'Промо',
      vps: 'VPS',
      logout: 'Выйти',
    },
    header: {
      promotion: 'Промоушен',
      balance: 'Баланс',
      technicalSupport: 'Техническая поддержка',
      mentor: 'Наставник',
    },
    profile: {
      main: 'Основное',
      fullName: 'ФИО',
      loginUsername: 'Логин (имя пользователя)',
      birthDate: 'Дата рождения',
      country: 'Страна',
      email: 'Почта',
      phone: 'Телефон',
      telegram: 'телеграм',
      security: 'Безопасность',
      transactionConfirmation: 'Подтверждение операций',
      changePassword: 'Сменить пароль',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      confirmNewPassword: 'Подтвердите новый пароль',
      enterOldPassword: 'Введите старый пароль',
      enterNewPassword: 'Введите новый пароль',
      confirmPassword: 'Подтвердите пароль',
      invalidPasswordCharacter: 'Использован недопустимый символ. Разрешены: латиница, цифры и !@#$%^&*()-+',
      passwordComplexity: 'Пароль должен содержать минимум 2 из 4: строчные буквы, заглавные буквы, цифры, спецсимволы',
      passwordsMustMatch: 'Пароли должны совпадать!',
      save: 'Сохранить',
      lastName: 'Фамилия',
      firstName: 'Имя',
      middleName: 'Отчество',
      enterLastName: 'Введите Фамилию',
      enterFirstName: 'Введите Имя',
      enterMiddleName: 'Введите Отчество',
      lastNameExample: 'Петров',
      firstNameExample: 'Иван',
      middleNameExample: 'Андреевич',
      phoneFormat: 'Телефон должен быть в формате +79997768879',
      phoneLength: 'Телефон должен быть от 11 до 15 сиволов',
      telegramRequirements:
        'Телеграм должен имеет только латинские символы, в начале содержать @ и иметь длину от 5 до 31 символа',
      enterPhoneNumber: 'Введите ваш номер телефона',
      enterTelegramNickname: 'Введите ваш ник телеграм',
      countryPlaceholder: 'Греция',
      moscow: 'Москва',
      confirmationByEmail: 'По почте',
      googleAuthenticator: '2FA Google Authenticator',
      error: 'Ошибка',
      phoneRequiredForTwoFactor: 'Необходимо добавить номер телефона в настройках профиля.',
    },
    verification: {
      title: 'Верификация',
      passportPhotoRequired: 'Для верификации аккаунта необходимо отправить фото паспорта',
      instruction: 'Инструкция',
      takePhotoAsExample: 'Cделайте фото как на примере',
      addPhotoToForm: 'Добавьте фото в форму',
      sendForReviewInstruction: 'Нажмите кнопку “Отправить на проверке”',
      mainPassportSpread: '1. Главный разворот',
      registrationAddress: '2. Прописка',
      addPhoto: 'Добавьте фото',
      chooseFile: 'Выбрать файл',
      photoRequirements: 'Требования к фото',
      takesUpToFiveDays: 'Верификация займет до 5 дней',
      send: 'Отправить',
      sendForReview: 'Отправить на проверку',
      documentsUnderReview: 'Документы на проверке',
      verificationError: 'Ошибка верификации',
      repeatVerificationRequired: 'Необходимо повторно пройти верификацию',
      repeatVerification: 'Пройти верификацию повторно',
      startVerification: 'Пройти верификацию',
    },
    accountRemoval: {
      removeAllData: 'Удалить мой аккаунт и все данные',
      title: 'Удаление аккаунта',
      confirmation: 'Вы уверенны что хотите удалить аккаунт и все данные? ',
      remove: 'Удалить',
      informationalNotice: 'Информационное уведомление',
      reasonNoLongerClient: 'Я больше не хочу быть клиентом',
      reasonAnotherAccount: 'Хочу создать другой аккаунт',
      reasonOther: 'Другие причины',
      warnings: 'Предупреждения',
      warningIrreversible: 'Удаляя свой личный аккаунт вы больше не сможете восстановить данные',
      warningBalance: 'Весь ваш прогресс и денежные средства на балансе будут удалены',
      warningProducts: 'Вы больше не сможете воспользоваться продуктами компании, приобретенными на этот аккаунт',
      warningsAcknowledged: 'Я ознакомился с предупреждениями',
      codeSentToEmail: 'Введите код, который мы отправили вам на почту',
      removeAccount: 'Удалить аккаунт',
    },
    finance: {
      balance: 'Баланс:',
      processing: 'В обработке:',
      inProcessing: 'В обработке',
      withdrawn: 'Выведено:',
      transactionHistory: 'история транзакций',
      completed: 'Выполнено',
      cancelled: 'Отмена',
      transactionId: 'id транзакции',
      recipient: 'Кому',
      sender: 'от кого',
      description: 'Описание',
      paymentMethod: 'Способ оплаты',
      cancelTransaction: 'Отменить транзакицию',
      noTransactions: 'Транзакций нет',
      cancellationConfirmation: 'Подтверждение отмены транзакции',
      yes: 'Да',
      filter: 'Фильтр',
      byDate: 'По дате',
      enterUsername: 'Введите имя пользователя',
      enterDescription: 'Введите описание',
      selectPaymentMethod: 'Выберите способ оплаты',
      show: 'Показать',
      purchase: 'Покупка',
      withdrawal: 'Вывод',
      matchingBonus: 'Матчинг бонус',
      companyReward: 'Вознаграждение от компании',
      other: 'Другое',
      withdrawalNotice: 'Вывод может занять до двух рабочих дней ',
      instruction: 'Инструкция',
      withdrawalStepDetails: 'Введите сеть, укажите адрес и сумму вывода',
      withdrawalStepVerify: 'Подтвердите корректность данных ',
      withdrawalStepConfirm: 'Подтвердите транзакцию ',
      chooseCoin: 'Выберите монету',
      coin: 'Монета',
      chooseNetwork: 'Выберите сеть',
      cryptocurrencyNetwork: 'Криптовалютная сеть',
      walletAddressInNetwork: 'Введите адрес кошелька в выбранной сети',
      enterWalletAddress: 'Введите адрес кошелька',
      enterAmount: 'введите сумму',
      minimumWithdrawalAmount: 'Минимальная сумма вывода {{amount}}',
      minimumWithdrawalError: 'Минимальная сумма вывода {{amount}} USDT',
      walletLengthError: 'Длина кошелька превышает 50 символов',
      invalidAmount: 'Вы ввели неверную сумму',
      invalidIntegerAmount: 'Вы ввели неверную сумму. Сумма для вывода должна быть целым числом',
      insufficientFunds: 'У вас недостаточно средств на счете',
      withdrawBonuses: 'Вывести бонусы',
    },
    notifications: {
      title: 'Уведомления',
      empty: 'Уведомлений нет',
      dateTime: '{{date}} в {{time}}',
    },
    events: {
      online: 'Онлайн',
      offline: 'Оффлайн',
      readMore: 'Подробнее',
      title: 'Мероприятия',
      back: 'Назад',
      nextArticle: 'Следующая статья',
      futureEvents: 'Будущие мероприятия',
      pastEvents: 'Прошедшие мероприятия',
    },
    marketing: {
      title: 'Маркетинг',
      description:
        'В данном разделе вы сможете изучить все правила и условия начисления вознаграждений за продвижение продуктов компании, а также всю необходимую информацию по построению онлайн бизнеса.',
      companyPlanTitle: 'Маркетинг план компании FT Holding Trade',
      companyPlanDescription:
        'В данном разделе Вы сможете изучить все правила и условия начисления вознаграждений за продвижение продуктов компании, а также всю необходимую информацию по построению онлайн бизнеса.',
      goTo: 'Перейти',
      readMore: 'Подробнее',
      materials: {
        fastStart: {
          title: 'Бонус быстрого старта',
          summary:
            'Это дополнительный процент за личные рекомендации. Чтобы получить быстрый старт, необходимо приобрести 1, 3 или 5 торговых систем...',
          sections: [
            `Это дополнительный процент за личные рекомендации.

Чтобы получить быстрый старт, необходимо приобрести 1, 3 или 5 торговых систем
В компании также представлен еще один бонус, бонус быстрого старта, он действует первые 30 дней с момента покупки торговой системы.

Приобретая одну торговую систему, вы получаете 3% дополнительного дохода с каждой личной продажи.

Если вы приобрели 3 торговых системы, вы получаете 6% дополнительного дохода с каждой личной продажи, приобретая 5 торговых систем, вы получаете 9% дополнительного дохода с каждой личной продажи.`,
          ],
        },
        matchingBonus: {
          title: 'Матчинг бонус',
          summary:
            'Матчинг бонус выплачивается вам с каждой продажи в вашей структуре. С 5 уровня каждый партнер получает статус директора...',
          sections: [
            `Матчинг бонус выплачивается вам с каждой продажи в вашей структуре.
С 5 уровня каждый партнер получает статус директора...
Получает уникальный ID структуры и матчинг бонус.
Матчинг бонус выплачивается вам с каждой продажи в вашей структуре.
Этот бонус выплачивается вместе с командным.
Начиная от 0,5 до 5% соответственно с каждой продажи.
Когда у вас структуре появляется еще один директор пятого уровня, то теперь он тоже получает матчинг со своей структуры, тем самым у вас теперь тоже образуется разница в доходе.
Если ваш партнер 5 уровня, он получает 0.5% матчинга со всей своей структуры.
Тогда вы будете получать свой процент за минусом этих 0,5% с его структурной ветки.
Если же он на 6 уровне, то он получает 1% матчинга со своей структуры, а вы получаете на 1% меньше с его структуры.
Если нижестоящий партнер достигает того же карьерного уровня, что и вы, то вы перестаете зарабатывать с его структуры, потому что между вами нет разницы, и этот партнер забирает все бонусы.
Это условие действует на командный и матчинг бонус.`,
          ],
        },
        units: {
          title: 'Расчёт единиц',
          summary:
            'В компании имеется ранговая система, которая называется Карьерный уровень, карьерные уровни достигаются путём продажи продуктов компании Вами и вашими партнёрами...',
          sections: [
            `В компании имеется ранговая система, которая называется Карьерный уровень, карьерные уровни достигаются путём продажи продуктов компании Вами и вашими партнёрами.

Так для перехода на следующий уровень вам необходимо определённое количество Единиц.

Единица - это мера измерения, которая показывает товарооборот партнёра и его команды в компании, и определяет уровень, на котором должен находиться каждый партнёр, согласно своему товарообороту.`,
            `В компании представлена формула, по которой Вы сможете посчитать какое количество единиц Вы получите от продажи любого товара компании.

СУММА ТОВАРА / 500 = количество единиц.

Дословно - сумма покупки клиента делится на коэффициент 500 и вы получаете количество единиц за товарооборот!
Как посчитать товарооборот и единицы?

В компании представлена формула, по которой Вы сможете посчитать какое количество единиц Вы получите от продажи любого товара компании.

СУММА ТОВАРА / 500 = количество единиц.

Дословно - сумма покупки клиента делится на коэффициент 500 и вы получаете количество единиц за товарооборот!`,
          ],
        },
        career: {
          title: 'Как открыть карьеру FT Holding Trade?',
          summary:
            'Первое условие - система активности, при который Вы можете получить доступ к бизнесу и расти по карьере. Второе условие - это наличие торговых систем для активации всех уровней маркетинг плана компании. В компании реализовано 2 условия. Первое условие - система активности, при который Вы можете получить доступ к бизнесу и расти по карьере. Второе условие - это наличие торговых систем для активации всех уровней маркетинг плана компании.',
          sections: [
            `Разберём подробнее первое условие:

В карьере имеется 11 уровней, начиная с нулевого (0) уровня, до десятого (10) уровня соответственно.

Чтобы получить нулевой уровень, вам достаточно зарегистрировать аккаунт по реферальной ссылке партнёра компании, и уже сразу после регистрации вы можете начать делать бизнес с доходом 15% от стоимости любого продукта.
Это льготный уровень для всех партнёров компании, которые хотят начать делать бизнес, но по разным причинам пока не могут приобрести торговую систему.
Чтобы перейти на первый уровень, вам необходимо приобрести 1 торговую систему или обучение в школе трейдинга пакет Профессионал.

Приобретая один из этих продуктов, вы получаете 1 год доступа к бизнес карьере компании.

Если же вы приобрели 2 торговых системы, то вы получаете сразу 2 года доступа к карьере компании.

Если вы приобрели сразу 5 торговых систем, вы получаете 5 лет доступа к карьере компании и так далее.

1 торговая система = +365 дней доступа к карьере компании.
Теперь разберём второе условие:

Имея 1 торговую систему, вы открываете доступ к карьере с 1-го по 4-ый уровень. Таким образом вы можете дойти до 4-го уровня по карьере за 365 дней, если же вы хотите продвигаться дальше и зарабатывать больше, вам необходимо приобрести еще 2 торговых системы.

Имея 3 торговых системы вы открываете карьеру с 1-го по 7-ой уровень. То есть у вас есть 3 года на то, чтобы дойти до 7 уровня.`,
            `Если вы хотите открыть все 10 уровней, вам необходимо приобрести 5 торговых систем, таким образом вы активируете все 10 карьерных уровней, получите доступ к маркетинг плану на 5 лет и сможете зарабатывать до 45% от стоимости продукта с каждой личной продажи.

Торговые системы можно приобретать по мере продвижения по уровням.

Лицензии на торговые системы безлимитные и покупая вы получаете их навсегда.

Чтобы узнать как продвигаться по карьере и достигать новые уровни, рекомендуем посмотреть Видео на главной странице Маркетинг.`,
          ],
        },
      },
    },
    partners: {
      structureTree: 'Древо структуры',
      resetFilter: 'сбросить фильтр',
      selectSortingMethod: 'Выберите способ сортировки',
      loginOrPartnerEmail: 'Логин или почта партнера',
      partnerId: 'ID партнера',
      qualification: 'Квалификация',
      personalSales: 'Личные продажи',
      applyFilter: 'применить фильтр',
      firstLinePartnersCount: 'Количество партнеров в первой линии',
      noPartners: 'Партнеры отсутствуют',
      dataNotFound: 'Данные не найдены',
      partnerLinks: 'Партнерские ссылки',
      partnerLinksHint: 'Создавайте партнерские ссылки для быстрого доступа.',
      addPartnerLink: 'Добавить партнерскую ссылку',
      editPartnerLink: 'Редактировать партнерскую ссылку',
      companyName: 'Название компании',
      enterCompanyName: 'Введите название компании',
      pasteLink: 'Вставьте ссылку',
      enterLink: 'Введите ссылку',
      add: 'Добавить',
      edit: 'Изменить',
      maximumCharacters: 'Максимум {{count}} символов',
      deleteLinkTitle: 'Подтверждение удаления ссылки',
      deleteLinkDescription: 'Вы уверены что хотите удалить ссылку?',
      yes: 'Да',
      fastStartBonus: 'Бонус быстрый старт',
      daysRemaining: 'Осталось {{count}} дней',
      nextQualification: 'Следующая квалификация',
      progress: 'Прогресс',
      teamSales: 'Командные продажи',
      incomePercentage: 'Мой процент дохода',
      matchingBonus: 'Матчинг бонус',
      technicalSupportUntil: 'Техподдержка до:',
      technicalSupport: 'Техподдержка:',
      inactive: 'не активна',
    },
    statistics: {
      personalRegistrations: 'Личных регистраций',
      personalSales: 'Личные продажи',
      teamRegistrations: 'Командные регистрации',
      teamSales: 'Командные продажи',
      salesAndRegistrationsDynamics: 'Динамика личных / командных продаж и регистраций.',
      showAllLines: 'Показать все {{count}} линий',
      lines: 'Линии',
      line: '{{count}} линия',
      noOpenLines: 'Нет открытых линий',
      week: 'Неделя',
      month: 'Месяц',
      halfYear: 'Полгода',
      year: 'Год',
      period: 'Период',
    },
    calculator: {
      compoundInterest: 'сложный процент',
      mortgage: 'Ипотека',
      financialFreedom: 'финансовая свобода',
      travel: 'Путешествия',
      pleasantPurchases: 'Приятные покупки',
      dreamCar: 'Автомобиль мечты',
      bestParent: 'Быть лучшим родителем',
      partnerCalculator: 'Калькулятор партнера',
      currency: 'Валюта',
      ruble: 'рубль',
      dollar: 'доллар',
      euro: 'евро',
      buyTradingSystem: 'Купить торговую систему',
      downloadPdf: 'Скачать PDF',
      downloadPng: 'Скачать PNG',
      detailedCalculation: 'Подробный расчет',
      fillAllFields: 'Для отображения подробного расчета заполните все поля',
      investmentTotals: 'Итоги инвестирования',
      totalResult: 'Итого',
      instructions: 'Инструкция',
      year: 'Год',
      month: 'Месяц',
      date: 'Дата',
      capitalAtTermStart: 'Капитал на начало срока',
      startingCapitalAtTermStart: 'Стартовый капитал на начало срока',
      additionalInvestments: 'Дополнительные вложения',
      additionalInvestmentsAmount: 'Сумма дополнительных вложений',
      profit: 'Прибыль',
      total: 'Итог',
      investmentAmount: 'Сумма вложений',
      monthlyProfit: 'Ежемесячная прибыль',
      monthlyProfitCar: 'Ежемесячеая прибыль',
      mortgagePayment: 'Сумма ипотечного платежа',
      deposit: 'Депозит',
      carLoanPayment: 'Оплата автокредита',
      moneyInAccount: 'Деньги на счету',
      totalAmount: 'Общая сумма',
      level: 'Уровень',
      levelNumber: '{{count}} уровень',
      salesAmount: 'Сумма продаж',
      mortgageDescription: 'Доход от торговой системы позволит перекрыть <br /> ежемесячный платеж по ипотеке.',
      monthlyMortgagePayment: 'ВВЕДИТЕ СУММУ ЕЖЕМЕСЯЧНОГО ПЛАТЕЖА ПО ИПОТЕКЕ',
      monthlyInvestmentAmount: 'ВВЕДИТЕ СУММУ, КОТОРУЮ ВЫ МОЖЕТЕ ИНВЕСТИРОВАТЬ ЕЖЕМЕСЯЧНО',
      immediateDeposit: 'КАКУЮ СУММУ ВЫ ГОТОВЫ ВНЕСТИ СРАЗУ',
      mortgageResult:
        'Если каждый месяц вносить сумму на счет, то доходы от торговой системы перекроют ежемесячный платеж по ипотеке через:',
      monthUnit_one: '{{count}} месяц',
      monthUnit_few: '{{count}} месяца',
      monthUnit_many: '{{count}} месяцев',
      monthUnit_other: '{{count}} месяца',
      yearUnit_one: '{{count}} год',
      yearUnit_few: '{{count}} года',
      yearUnit_many: '{{count}} лет',
      yearUnit_other: '{{count}} года',
      durationWithYears: '{{years}} и {{months}}',
      dreamCarDescription: 'Купите автомобиль вашей мечты! <br /> А доход от торговых систем покроет все расходы.',
      carPrice: 'введите стоимость автомобиля, который вы хотите купить',
      carPurchaseDeposit: 'Для покупки вам понадобится положить на счет',
      instructionStage: 'Этап {{count}}',
      mortgageInstruction1: 'Приобретаем торговую систему',
      mortgageInstruction2: 'Размещаем депозит {{amount}}',
      mortgageInstruction3: 'Накапливаем депозит {{amount}} с ежемесячной прибыли',
      mortgageInstruction4: 'Получая ежемесячную прибыль {{profit}}, оплачиваем ипотеку в размере {{payment}}',
      mortgageInstructionTotal:
        'Генерируя прибыль {{profit}}, торговая система полностью перекрывает обязательства по ипотечному платежу, и теперь нам не нужно платить за ипотеку из своего кармана',
      carInstruction1: 'Приобретаем USDT на {{amount}}',
      carInstruction2: 'Приобретаем необходимое количество торговых систем',
      carInstruction3: 'Размещаем сумму {{amount}} на депозит',
      carInstruction4: 'Приобретаем Авто в кредит на 1 год с первым взносом 20% от стоимости авто',
      carInstruction5:
        'Получаем ежемесячный доход {{income}} и оплачиваем {{payment}} за автокредит, а остальное докладываем на баланс торговой системы',
      carInstruction6: 'Закрываем все 12 месяцев ежемесячными платежами, из доходности от торговой системы',
      carTotal1: 'Мы сохранили депозит {{deposit}} и купили автомобиль',
      carTotal2: 'Получаем ежемесячный доход {{income}}',
      carTotal3: 'Можем планировать следующую покупку или жить на деньги от инвестиций!',
      blockDescription1:
        'Это инструмент, с помощью которого вы можете посчитать стратегию по инвестированию с нашими торговыми системами!',
      blockDescription2:
        'Здесь Вы узнаете как создать пенсию, накопить на будущее детям, ежегодно путешествовать по миру за счет пассивного дохода и многое другое!',
      blockDescription3:
        'Данный инструмент можно использовать как для личного использования, так и для продаж вашим клиентам',
      fillChartFields: 'Для отображения графика заполните все поля',
      fillDiagramFields: 'Для отображения диаграммы заполните все поля',
      compoundInterestTitle: 'Сложный процент',
      compoundInterestDescription:
        'Сложный процент — это процент, который начисляется на начальную сумму вложений, а также на проценты, накопленные за предыдущие периоды. Начисление сложных процентов предполагает реинвестирование полученного дохода.',
      startingCapital: 'Стартовый капитал',
      investmentTerm: 'Срок инвестирования',
      additionalMonthlyInvestments: 'Дополнительные вложения в месяц',
      withdrawProfitMonthly: 'Выводим прибыль ежемесячно',
      reinvestMonthly: 'Реинвестировать ежемесячно',
      monthUpper: 'МЕСЯЦ',
      yearUpper: 'ГОД',
      monthlyRate: 'Ставка в месяц',
      investmentResult: 'Результат инвестирования',
      financialFreedomTitle: 'Финансовая свобода',
      financialFreedomDescription:
        'Хотите заняться самореализацией? Начните жить для себя. <br /> 1000 $ на счету сегодня - 110000$ через 10 лет.',
      oneTimeInvestment: 'Разовая инвестиция',
      accountAfterTime: 'через {{duration}} на счете будет',
      monthlyIncomeIs: 'ежемесяный доход составит',
      averageMonthlyReturn: 'при средней доходности 4% в месяц',
      monthlyContributions: 'Ежемесячные довложения',
      investmentTermLower: 'срок инвестирования',
      yearsUpper: 'ЛЕТ',
      bestParentDescription:
        'Доход от торговых систем позволит отправить вашего ребенка учиться в любой вуз мира или исполнить другие его мечты.',
      travelDescription: 'Путешествуйте спокойно, пока торговые системы приносят прибыль. <br /> Вы заслужили отпуск!',
      annualTravelAmount: 'Введите сумму, которую ежегодно хотите тратить на путешествия',
      requiredDeposit: 'Для получения такого дохода необходимо положить на счет',
      pleasantPurchasesTitle: 'Приятные покупки',
      pleasantPurchasesDescription:
        'Приобретайте желаемое, не тратя собственные средства. <br /> Благодаря доходу от торговых систем.',
      equipmentCost: 'Введите стоимость техники',
      partnerCalculatorTitle: 'Калькулятор партнера',
      partnerCalculatorDescription:
        'Калькулятор партнера поможет Вам рассчитать примерный доход с каждого вашего партнера в первой линии. Вы можете указать Ваш уровень и протестировать разные варианты продаж, чтобы увидеть, как много Вы сможете зарабатывать с каждой линии Ваших структур!',
      careerLevel: 'ваш карьерный уровень',
      yourSales: 'Ваши продажи',
      salesAtLevel: 'Продажи на уровне {{level}}',
      totalSales: 'Общая сумма продаж',
      travelAmount: 'Сумма на путешествия',
      purchaseAmount: 'Сумма для покупки',
      buyKeeper: 'Приобретаем торговую систему Keeper',
      depositAmount: 'Размещаем депозит {{amount}}',
      addMonthly: 'Пополняем ежемесячно {{amount}}',
      giveAccessToChildren: 'Через {{duration}} передаем доступы от кабинета детям',
      educationTotal:
        'Через {{duration}}, благодаря сложному проценту и ежемесячным довложениям в размере {{contribution}}, мы смогли накопить сумму {{total}} с ежемесячным доходом {{income}}',
      buyTradingSystemInstruction: 'Приобретаем торговую систему',
      monthlyProfitForCompound: 'Ежемесячно получаем прибыль и оставлем ее на балансе для создания сложного процента',
      balanceAfterTwelveMonths: 'Через 12 месяцев на балансе будет сумма {{amount}}',
      vacationTotal:
        'С депозитом всего {{deposit}}, за 12 месяцев при использовании сложного процента, мы накопим сумму {{profit}} прибыли и сможем поехать в путешествие',
      monthlyProfitForPurchase:
        'Ежемесячно получаем прибыль и оставлем ее на торговой системе для создания сложного процента',
      purchaseTotal:
        'С депозитом всего {{deposit}}, за 12 месяцев при использовании сложного процента, мы накопим сумму {{profit}} прибыли и сможем приобрести новый iphone.',
      retireAfter: 'Через {{duration}} выходим на пенсию',
      financialFreedomTotal:
        'Через {{duration}}, благодаря сложному проценту и ежемесячным довложениям в размере {{contribution}}, мы смогли накопить сумму {{total}} с ежемесячным доходом {{income}}',
      totalForYear: 'Итого за год',
    },
    cart: {
      title: 'Корзина',
      empty: 'Корзина пустая',
      goToStore: 'Перейти в магазин',
      total: 'ИТОГО:',
      pay: 'Оплатить',
      products: 'Продукты',
      confirmPayment: 'Подтвердите оплату',
      close: 'Закрыть',
      error: 'Ошибка!',
      done: 'Готово!',
      paymentSuccessful: 'Оплата прошла успешно',
      purchaseCompleted: 'Покупка оформлена',
      purchaseWillBeCredited: 'После подтверждения оплаты продукт будет начислен на ваш личный кабинет',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      paymentMethod: 'Выберите способ оплаты',
      chooseCoin: 'Выберите монету',
      coin: 'Монета',
      chooseNetwork: 'Выберите сеть',
      cryptocurrencyNetwork: 'Криптовалютная сеть',
      noPaymentNetworks: 'Для этой монеты сейчас нет доступных сетей оплаты.',
      pleaseWait: 'Ожидайте пожалуйста.',
      invoiceCreated: 'Счёт на оплату создан',
      amountDue: 'К оплате: {{amount}}',
      paymentPageCoinAndNetwork: 'На странице оплаты вы сможете выбрать нужную вам монету и сеть',
      paymentConfirmedAutomatically:
        'Оплата подтверждается автоматически, в среднем в течение минуты после перевода средств',
      goToPaymentPage: 'Перейти на страницу оплаты',
      creatingInvoice: 'Создаём счёт…',
      operationFailed: 'Не удалось выполнить операцию. Попробуйте ещё раз.',
      recalculationFailed: 'Не удалось пересчитать техподдержку',
      invoiceCreationFailed: 'Не удалось создать счёт на оплату',
      receiptUploadFailed: 'Не удалось загрузить чек. Попробуйте ещё раз.',
      minimumPurchaseAmount: 'Минимальная сумма покупки {{amount}}',
      receiptUploadError: 'Не удалось загрузить чек',
      invalidFileType: 'Недопустимый тип файла. Разрешены: {{extensions}}',
      fileTooLarge: 'Файл больше 10 МБ.',
      uploadPaymentScreenshot: 'Загрузите скриншот с оплатой',
      sendPaymentToAddress: 'Отправьте сумму на указанный адрес и нажмите кнопку "Я оплатил"',
      network: 'Сеть',
      wallet: 'Кошелек',
      walletCopied: 'Кошелёк скопирован',
      amount: 'Сумма',
      payByQr: 'Оплатить по QR-коду',
      receiptProcessing: 'Обработка чека. Ожидайте пожалуйста.',
      paid: 'Я оплатил',
      quantity: 'Количество: {{count}}',
      technicalSupportMonths: 'Кол-во месяцев тех поддержки: {{count}}',
      purchaseCommission: 'Комиссия за покупку:',
      paymentUnavailable: 'Оплата временно недоступна. Попробуйте позже.',
      warning: 'Внимание!',
      cryptoAddressWarning: 'Этот адрес предназначен только для переводов {{coin}} по протоколу {{network}}.',
      noSmartContractTransfers:
        'Не отправляйте на него переводы со смарт-контрактов, монеты {{baseCoin}} или любую другую криптовалюту. Такие переводы зачислены не будут!',
      transferExactAmount: 'Переведите точную сумму (Сумма за продукты) {{coin}} на указанный адрес одной транзакцией.',
      amlMonitoring: 'Осуществляется мониторинг криптовалютных пополнений согласно нашей AML-программе.',
      receiptSample: 'ОБРАЗЕЦ ЧЕКА',
      withdrawalDetails: 'Детали вывода',
      withdrawalCompleted: 'Вывод завершён',
      account: 'Аккаунт',
      fundingAccount: 'Аккаунт финансирования',
      networkType: 'Вид сети',
      commission: 'Комиссия',
      time: 'Время',
      walletAddress: 'Адрес кошелька',
      transactionHash: 'Хэш транзакции (TXID)',
      receiptSampleAbove: 'Образец чека указан выше',
      receiptRequirementDate: '1. Дата и время транзакции',
      receiptRequirementHash: '2. HASH или TXID транзакции',
      receiptRequirementAmount: '3. Сумма',
      receiptRequirementWallet: '4. Адрес кошелька на который отправили средства',
      receiptAnyFormat: 'Разновидность чеков может быть любой, главное указать 4 типа данных',
      serverUpgrade: 'Улучшение',
      serverProlongation: 'Продление',
      numberOfMonths: 'Количество месяцев',
      termToIssue: 'на какой срок оформить',
      numberOfProducts: 'Количество продуктов',
      dependsOnSystems: 'зависит от количества систем',
      subscriptionTerm: 'срок подписки',
      numberOfServers: 'Количество серверов',
      serversToAdd: 'сколько серверов добавить',
      oneServer: 'один сервер',
      oneSubscription: 'одна подписка',
      tariffUpgrade: 'Улучшение тарифа: {{from}} → {{to}}',
      tariffUpgradePrefix: 'Улучшение тарифа:',
      serverTariffUpgrade: 'Улучшение тарифа сервера',
      serverId: 'Сервер ID {{id}}',
      durationDiscount: 'Скидка за срок {{percent}}% (без скидки — {{amount}})',
      technicalSupportRecalculation:
        'Если у вас больше одной торговой системы, стоимость техподдержки будет автоматически пересчитана с учётом их количества',
      quantityLabel: 'Количество',
    },
    products: {
      addedToCart: 'Продукт успешно добавлен в корзину',
      addToCart: 'Добавить в корзину',
      pay: 'Оплатить',
      sentToPartner: 'Продукт успешно отправлен партнёру',
      partnerEmailOrLoginError: 'Oшибка неправильная почта или имя пользователя партнера',
      tryAgain: 'Попробовать ещё раз',
      enterPartnerEmailOrLogin: 'Введите почту или логин партнера',
      sendToPartner: 'Отправить Партнеру',
      activate: 'Активировать',
      ourProducts: 'Наши продукты',
      purchasedProducts: 'Купленные продукты',
      tradingSystems: 'Торговые системы',
      technicalSupport: 'Техническая поддержка',
      activeUntil: 'Активна до',
      inactive: 'Не активна',
      renewSupport: 'Продлить поддержку',
      installationInstructions: 'Инструкция по установке',
      totalQuantity: 'Общее кол-во: {{count}}',
      activationRequired: 'Необходимо активировать продукт',
      subscriptionAdded: 'Подписка добавлена в корзину',
      subscriptionAddFailed: 'Не удалось добавить подписку в корзину',
      perMonth: '/ мес.',
      subscriptionActive: 'Активна с {{from}} до {{to}}',
      telegramLinked: 'Telegram привязан',
      relink: 'Перепривязать',
      unlinkTelegram: 'Отвязать {{username}}? Сигналы перестанут приходить в этот Telegram.',
      unlink: 'Отвязать',
      linkTelegram: 'Привязать TG',
      subscriptionExpired: 'Подписка закончилась {{date}}',
      renew: 'Продлить',
      applyForInstallation: 'Подать заявку на установку?',
      installationInstructionsTitle: 'Инструкции по установке',
      videoInstruction: 'Видео инструкция',
      open: 'Открыть',
      pdfInstruction: 'PDF инструкция',
      download: 'Скачать',
      mentorHelp: 'Помощь наставника',
      goTo: 'Перейти',
      later: 'Позже',
      yes: 'Да',
      skip: 'Пропустить',
      submitApplication: 'Подать заявку',
      activeOne: 'Активный продукт',
      activeFew: 'Активных продукта',
      activeMany: 'Активных продуктов',
      archivedOne: 'Архивированный продукт',
      archivedFew: 'Архивированных продукта',
      archivedMany: 'Архивированных продуктов',
      monthsOne: '{{count}} месяц',
      monthsFew: '{{count}} месяца',
      monthsMany: '{{count}} месяцев',
      inCartFor: 'В корзине: {{period}}',
      subscriptionUnavailable: 'Подписка на сигналы сейчас недоступна',
      currentTelegram: 'текущий Telegram',
      activeStatus: 'Активно',
      activeStatusWithCount: 'Активно: {{count}}',
      archivedStatus: 'В архиве',
      archivedStatusWithCount: 'В архиве: {{count}}',
    },
    vps: {
      active: 'Активен',
      awaitingPayment: 'Ожидает оплаты',
      provisioning: 'Создание',
      expired: 'Подписка истекла',
      blocked: 'Заблокирован',
      error: 'Ошибка',
      unknown: 'Неизвестно',
      deleted: 'Удалён',
      expiredNotice:
        'Подписка истекла. Продлите в течение {{days}} дней, иначе сервер и данные будут удалены. На сервер можно войти, но вместо рабочего стола будет экран с предложением продлить.',
      blockedNotice: 'Доступ к серверу заблокирован администратором. Обратитесь в поддержку.',
      permanent: 'Бессрочно',
      gateway: 'ШЛЮЗ',
      activeServers: 'Активные серверы',
      plan: 'План',
      issued: 'Выдан',
      paidUntil: 'Оплачен до',
      accessData: 'Данные для входа',
      upgrade: 'Изменить тариф',
      renew: 'Продлить',
      total: 'Всего:',
      noActiveServers: 'У вас нет активных серверов',
      tariffPlans: 'Тарифные планы',
      faq: 'FAQ & Помощь',
      generalQuestions: 'Общие вопросы',
      serviceOperation: 'Работа сервиса',
      tradingTerminals: 'Торговые терминалы',
      performance: 'Производительность',
      security: 'Безопасность',
      technicalSupport: 'Техническая поддержка',
      needConsultation: 'Нужна консультация?',
      consultationText: 'Наши специалисты помогут подобрать оптимальный сервер для ваших задач.',
      contactUs: 'Связаться с нами',
      popular: 'Популярный',
      server: 'Сервер',
      order: 'Заказать',
      select: 'Выберите',
      login: 'ЛОГИН',
      password: 'ПАРОЛЬ',
      ipAddress: 'IP АДРЕС',
      downloadAccessFile: 'Скачать файл для входа на VPS',
      accessHint:
        'Воспользуйтесь удобной функцией быстрого доступа к VPS. Нажмите на кнопку выше, запустите скачанный файл и укажите пароль от VPS',
      serverRenewal: 'Продление сервера',
      tariff: 'ТАРИФ',
      amountDue: 'К оплате',
      renewVps: 'Продлить VPS',
      serverUpgrade: 'Улучшение сервера',
      loadingTariffs: 'Загрузка доступных тарифов…',
      unavailableUpgrades: 'Не удалось загрузить доступные улучшения. Попробуйте позже.',
      maximumTariff: 'Сервер уже на максимальном тарифе.',
      surcharge: 'Доплата',
      selectTariff: 'Выберите тариф',
      surchargeHint: 'Доплата рассчитана за оставшиеся {{days}} дн. до конца оплаченного периода',
      upgradeVps: 'Изменить тариф',
      renewalRequiredHint: 'Минимальная сумма покупки {{amount}} $, доплаты за улучшение не хватает. Чтобы оформить покупку, продлите сервер минимум на {{period}}',
      renewalTotal: 'Итого: {{surcharge}} $ улучшение + {{renewal}} $ продление',
      renewalMinHint: 'Минимальная сумма оплаты {{amount}} $, поэтому подобран минимальный срок продления: {{period}}. Срок можно увеличить.',
      productAddedToCart: 'Продукт успешно добавлен в корзину',
      renewalAddedToCart: 'Сервер для продления успешно добавлен в корзину',
      upgradeAddedToCart: 'Улучшение сервера успешно добавлено в корзину',
      terminalOne: 'терминал',
      terminalFew: 'терминала',
      terminalMany: 'терминалов',
    },
    auth: {
      signInTitle: 'Авторизация',
      resetPasswordTitle: 'Восстановление пароля',
      signIn: 'Войти',
      signInToAccount: 'Войти в аккаунт',
      register: 'Регистрация',
      registerAction: 'Зарегистрироваться',
      haveAccount: 'Есть аккаунт?',
      noAccount: 'Нет аккаунта?',
      continue: 'Продолжить',
      confirm: 'Подтвердить',
      back: 'Вернуться назад',
      returnToLogin: 'Вернуться к входу?',
      email: 'Почта',
      login: 'Логин',
      password: 'Пароль',
      repeatPassword: 'Повторите пароль',
      partnerCode: 'Код партнёра',
      emailConfirmationCode: 'Код подтверждения почты',
      confirmationCode: 'Код подтверждения',
      confirmationMethod: 'Способ подтверждения',
      confirmByEmail: 'По почте',
      confirmByGoogle: 'По Google Authenticator',
      clearData: 'Очистить данные',
      forgotPassword: 'Забыли пароль?',
      passwordSent: 'Новый пароль отправлен на почту {{email}}',
      waitForCode: 'Ожидайте код подтверждения в течении {{count}} сек',
      signInConsent:
        'Авторизуясь, вы принимаете условия изложенные в наших документах и подтверждаете, что вам не менее 18 лет.',
      registrationConsent:
        'Регистрируясь, вы принимаете условия изложенные в наших документах и подтверждаете, что вам не менее 18 лет.',
      timeWarning: 'Время на устройстве не синхронизировано. Это может повлиять на корректность работы Google 2FA',
      documents: {
        publicOffer: 'Публичная оферта',
        privacyPolicy: 'Политика конфиденциальности',
        riskNotice: 'Уведомление о рисках',
        systemGuide: 'Инструкция по ЭВМ',
      },
      footer: {
        legalAddress: 'Юридический адрес:',
        registrationNumber:
          'Quijano Chambers, P.O. Box 3159, Road Town, Tortola, British Virgin Islands, государственный регистрационный номер 2156676',
        riskTitle: 'Предупреждение о рисках:',
        riskText:
          'при торговле продуктами с кредитным плечом, такими как CFD, существует высокий уровень риска. Вы не должны торговать или инвестировать, если вы полностью не понимаете истинную степень вашего риска потери. При торговле или инвестировании вы всегда должны учитывать уровень своего опыта, так как вы можете потерять средства при неправильном инвестировании. Если связанные с вами риски кажутся вам неясными, пожалуйста, обратитесь к внешнему специалисту за независимой консультацией',
      },
      googleAuthenticator: {
        downloadTitle: 'Скачайте Google Authenticator',
        downloadDescription:
          'Загрузите и установите приложение Authenticator на свой телефон, после этого привяжите свой аккаунт',
        downloadIos: 'Скачать Google Authenticator(IOS)',
        downloadAndroid: 'Скачать Google Authenticator(Android)',
        connectTitle: 'Привязать Google Authenticator',
        connectInstructionTitle: 'Привяжите Google Authenticator',
        openAndStart: 'Откройте приложении и нажмите “Начать”',
        chooseAuthenticationMethod: 'Выберите способ аутентификации',
        scanQrCode: 'Отсканируйте QR-код',
        enterKey: 'Введите ключ',
        keyCopied: 'Ключ скопирован',
        done: 'Готово',
        disconnectTitle: 'Отвязать Google Authenticator',
        disconnectConfirmation: 'Вы уверенны что хотите отвязать Google Authenticator?',
        disconnect: 'Отвязать',
        cancel: 'Отмена',
      },
      errors: {
        enterEmail: 'Введите почту',
        enterLogin: 'Введите логин',
        enterPassword: 'Введите пароль',
        enterPartnerCode: 'Введите реферальный код',
        enterConfirmationCode: 'Введите код подтверждения',
        enterEmailConfirmationCode: 'Введите код подтверждения почты',
        repeatPassword: 'Повторите пароль',
        invalidEmail: 'Почта некоректна',
        emailLatinOnly: 'Почта имеет латинские символы',
        loginLatinOnly: 'Логин должен иметь только латинские символы',
        loginLength: 'Длина логина должна быть от {{min}} до 36 символов',
        loginContainsAt: 'Логин содержит @',
        loginContainsSpaces: 'Логин содержит пробелы',
        loginCharacters: 'Логин может иметь только латинские буквы, цифры и спецсимволы .-_!',
        loginCharactersNoUppercase:
          'Логин может иметь только латинские буквы, цифры, спец символы .-_ и не должен содержать заглавне символы',
        loginNoUppercase: 'Логин не должен содержать заглавне символы',
        passwordCharacters: 'Пароль может содержать только латиницу, цифры и !@#$%^&*()-+',
        registrationPasswordCharacters:
          'Пароль может иметь только латинские буквы, цифры, и спец символы % & ! ? # $ * + , . - + : @ _',
        passwordComplexity: 'Пароль должен содержать минимум 2 из 4: строчные, заглавные, цифры, спецсимволы',
        codeLength: 'Код должен быть от 6 до 9 символов',
        invalidCode: 'Неверный код подтверждения',
        invalidCredentials: 'Неверный логин или пароль',
        sendCodeError: 'Ошибка при отправке сообщения на почту',
        selectMethod: 'Выберите способ подтверждения',
        emailTaken: 'Логин или почта заняты',
        weakPassword: 'Пароль слишком легкий',
        invalidReferralCode: 'Неправильный реферальный код',
        passwordsMismatch: 'Пароли не совпадают',
        referralLowercase: 'Реферальный код должен содержать хотя бы одну маленькую букву',
        referralUppercase: 'Реферальный код должен содержать хотя бы одну большую букву',
        referralDigit: 'Реферальный код должен содержать хотя бы одну цифру',
        referralLength: 'Код должен быть длиной {{length}} символов',
      },
    },
    promo: {
      windowTitle: 'ПРОМОУШЕН',
      learnMore: 'Узнать подробнее',
      materials: {
        title: 'Промо материалы',
        presentations: 'презентации',
        video: 'видео',
        photos: 'фото',
        reviews: 'отзывы',
        run: 'прогон',
      },
      summer: {
        imageAlt: 'Продлеваем главный розыгрыш до 1 октября',
        intro: 'Друзья, мы продлили для вас летний розыгрыш ценных призов от компании «FT Holding Trade»!',
        prizePlaces: '30 призовых мест —',
        prizePlacesDescription: 'на топовую технику и торговые системы',
        period: 'Срок проведения: 01.06.2026 — 01.10.2026',
        dontMissChance: 'Не упустить свой шанс!',
        conditionsTitle: 'УСЛОВИЯ УЧАСТИЯ:',
        participation: {
          lineOne: 'Для участия в розыгрыше',
          lineTwo: 'призов необходимо:',
          description: 'Совершить за весь период розыгрыша 2 покупки либо 2 продажи любых торговых систем',
          buyTicket: '2 покупки = 1 билет',
          sellTicket: '2 продажи = 1 билет',
          story: 'И сделать репост сторис в своем tg-аккаунте, отметив внизу ссылку на этот канал.',
          whatsapp: 'Нет телеграм-премиум? Можете выставить сторис в Whatsapp, отметив ссылку на данный канал',
        },
        prizeListTitle: 'Список призов:',
        prizeList: {
          1: '— MacBook Neo (5 шт.)',
          2: '— iPhone 17 Pro Max (5 шт.)',
          3: '— Планшет Samsung (5 шт.)',
          4: '— Apple Watch SE (5 шт.)',
          5: '— AirPods Pro (5 шт.)',
          6: '— Торговые системы, стоимостью 650$ (5 шт.)',
        },
        applicationTitle: 'Чтобы подать заявку на участие, необходимо:',
        codeWord: 'отправить кодовое слово «ЛЕТО» в отдел промоушена на получение билета участника',
        collectionStart: 'Старт сбора заявок: 1 июня 2026 г.',
        sendApplications: 'Заявки присылать сюда:',
        rulesTitle: 'ПРАВИЛА РОЗЫГРЫША:',
        collection: 'Сбор заявок:',
        collectionUntil: 'включительно до 00:00 по мск',
        results: 'Подведение итогов:',
        resultsDate: '05.10.2026 в 18:00 по мск',
        zoomLink: 'ссылка на zoom придет на канал техподдержки',
        finalTitle: 'Время пролетит незаметно. Станьте частью самого масштабного комьюнити трейдеров этого сезона',
        rules: {
          1: {
            before: 'Чтобы получить билет участника, необходимо быть подписанным на',
            link: 'основной канал',
            after: 'компании до окончания розыгрыша.',
          },
          2: 'Выиграть можно только одну позицию из 1-й категории призов. Если вы стали победителем дважды, то второй приз будет переигран.',
          3: 'Билеты за продажу и покупку НЕ СОВМЕЩАЮТСЯ, а считаются отдельно. То есть необходимо совершить 2 покупки ИЛИ 2 продажи, чтобы получить 1 билет участника.',
          4: 'Призы будут разыгрываться в онлайн-режиме на рандомайзере.',
          5: 'Передавать и передаривать свои билеты другим участникам нельзя.',
          6: 'Нельзя менять username (ник) в Telegram с момента старта и до окончания розыгрыша.',
          7: 'Присутствие в прямом эфире со своего личного аккаунта — ОБЯЗАТЕЛЬНО. За вас присутствовать не может никто.',
          8: 'При обнаружении мультиаккаунтов, повторных регистраций или любых других манипуляций с правилами, организаторы оставляют за собой право полностью дисквалифицировать участника и отказать в выдаче подарков.',
          9: 'Все выигранные призы (как гаджеты, так и торговые системы) выдаются строго в их первоначальном виде — замена подарков на их денежную стоимость в рамках данной акции не предусмотрена.',
        },
      },
      server: {
        modalTitle: 'РОЗЫГРЫШ В ЧЕСТЬ ВЫХОДА «FT SERVER»!',
        modalText:
          'Мы решили устроить новую акцию среди первых пользователей нашего нового продукта — FT Server. Приобретайте подписку на сервер и участвуйте в розыгрыше топовых призов!',
        collectionDates: 'Сроки проведения: 01.09.2026 — 01.12.2026',
        imageAlt: 'Розыгрыш в честь выхода FT Server',
        intro: 'Друзья, мы решили устроить новую акцию среди первых пользователей нашего нового продукта — FT Server',
        introAction: 'Приобретайте подписку на сервер и участвуйте в розыгрыше топовых призов!',
        infrastructure: {
          lineOne: 'Новая инфраструктура',
          lineTwo: 'Новые возможности',
          lineThree: 'Большие призы',
          descriptionOne: 'FT Server создан для стабильной работы торговых терминалов 24/7',
          descriptionTwo: 'В честь запуска мы разыгрываем три технологичных приза среди первых пользователей',
        },
        collection: 'Сбор заявок',
        results: 'Подведение итогов',
        resultsDate: '04.12.2026 в 17:00 МСК',
        dontMissChance: 'Не упустить свой шанс!',
        prizesTitle: 'ЧТО НА КОНУ?',
        conditionsTitle: 'УСЛОВИЯ УЧАСТИЯ',
        conditionsLead: 'Выберите тариф и срок подписки, соответствующий условиям розыгрыша:',
        startPlans: 'Standard 1 или Pro 3',
        advancedPlans: 'Business 5 или Enterprise 8 или Ultimate 15',
        twoYears: '2 ГОДА',
        oneYear: '1 ГОД',
        eligiblePayment: 'Одна соответствующая оплата даёт 1 право на участие',
        howToParticipate: 'КАК УЧАСТВОВАТЬ',
        rulesTitle: 'ПРАВИЛА РОЗЫГРЫША',
        finalTitle: 'Подключайте FT Server и забирайте свои подарки',
        finalLineOne: 'Два месяца',
        finalLineTwo: 'пролетят незаметно!',
        participate: 'Участвовать в розыгрыше',
        chooseFtServer: 'Выбрать FT Server',
        prizes: {
          first: {
            place: '1 МЕСТО',
            text: 'Станьте владельцем нового айфона, чтобы отслеживать работу своих торговых систем на максимальных скоростях',
          },
          second: {
            place: '2 МЕСТО',
            title: 'Скидка 50% на торговую систему FT',
            text: 'Доступно только для покупки систем стоимостью $650. Ваш пропуск в мир автоматизированного трейдинга за полцены',
          },
          third: {
            place: '3 МЕСТО',
            title: 'FT Server',
            subtitle: 'на 15 терминалов',
            text: 'Тариф Ultimate на 12 месяцев. Максимальная производительность и бесперебойная работа всех терминалов',
          },
        },
        steps: {
          first: {
            title: 'Приобретите подписку',
            lineOne: 'Standard 1 / Pro 3 — на 2 года.',
            lineTwo: 'Business 5 / Enterprise 8 / Ultimate 15 — на 1 год.',
          },
          second: { title: 'Отправьте кодовое слово', text: 'FT SERVER в @gtgcontrol' },
          third: { title: 'Получите билет участника', text: 'Получите официальный билет и ждите финала розыгрыша.' },
        },
        rules: {
          left: {
            1: 'В акции участвуют подписки на FT Server, оплаченные в период с 1 сентября по 1 декабря 2026 года',
            2: 'Для Standard 1 и Pro 3 условием участия является покупка сервера на срок от 2 лет',
            3: 'Для Business 5, Enterprise 8 и Ultimate 15 условием участия является покупка сервера на срок от 1 года',
            4: 'Каждая оплата, соответствующая условиям, даёт 1 право на участие в розыгрыше',
            5: 'Суммирование разрозненных платежей или частичная оплата не учитываются',
            6: 'Участником розыгрыша считается пользователь, получивший официальный билет участника после выполнения всех условий акции',
            7: 'Розыгрыш состоится 4 декабря в 17:00 МСК в прямом эфире',
          },
          right: {
            1: 'Победители определяются случайным образом среди участников, получивших билет участника.',
            2: 'Для получения приза участник должен присутствовать на прямой трансляции во время проведения розыгрыша',
            3: 'В случае возврата средств участие в акции автоматически аннулируется',
            4: 'Денежный эквивалент призов не выплачивается',
            5: 'Организатор вправе заменить приз на аналогичный по стоимости в случае отсутствия заявленной модели у поставщика',
            6: 'Организатор оставляет за собой право изменить сроки, условия и порядок проведения акции при возникновении форс-мажорных обстоятельств',
          },
        },
      },
    },
    support: {
      title: 'Поддержка',
      searchPlaceholder: 'Введите ваш вопрос',
      nothingFound: 'Ничего не найдено',
      popularTopics: 'Популярные темы',
      chatWithSupport: 'Чат с техподдержкой',
      askQuestion: 'Задать вопрос',
      followUs: 'Подписывайтесь на нас!',
      newsDescription: 'И будьте в курсе всех новостей',
      back: 'Назад',
      nextArticle: 'Следующая статья',
      relatedArticles: 'Еще по теме',
      article: {
        apiKeysQuestion: 'Где взять API ключи',
        apiKeysStepOne:
          'Для начала вам нужно пройти регистрацию на данной бирже.После этого перейдите в настройки API как на скрине ниже',
        apiKeysStepTwo: 'Далее введите название для вашего Api ключа и нажмите "API создан"',
        apiKeysStepThree:
          'После этого во всплывающем окне нажмите "Получить код" . Он придет вам на email на который зарегистрирован аккаунт Бинанс.',
        apiKeysStepFour:
          'Введите его в поле слева и введите код двухфакторной аутентификации. (рекомендуем для безопасности пользоваться двухфакторной аутентификацией).И кликните "Отправить".После этого отобразятся данные: API Key и Secret key. Сохраните эти данные. Так как Secret key при потере нельзя восстановить.',
        huobiQuestion: 'Создание Api ключа на Huobi',
        huobiStep:
          'Перейдите и авторизуйтесь на cайте Huobi. Затем в правом верхнем углу нажмите на значок профиля и выберите "Api Management".',
        binanceQuestion: 'Как создать API ключ на бирже binance',
      },
    },
    speedTest: {
      title: 'СКОРОСТЬ ИНТЕРНЕТА',
      download: 'ЗАГРУЗКА',
      upload: 'ВЫГРУЗКА',
      retry: 'ПОВТОРИТЬ',
      ratings: { 1: 'ОЧЕНЬ МЕДЛЕННО', 2: 'МЕДЛЕННО', 3: 'НОРМАЛЬНО', 4: 'ХОРОШО', 5: 'ОТЛИЧНО' },
    },
    academy: { title: 'Академия', open: 'Перейти' },
    currencyRates: { loadingError: 'Ошибка загрузки котировок', reload: 'Перезагрузить', loading: 'Загрузка...' },
    breadcrumbs: { partner: 'Партнеру', marketing: 'маркетинг' },
    news: { title: 'Новости', important: 'Важные новости' },
    p2p: {
      identityVerification: 'Подтверждения личности',
      higherInStructure: 'Выше по структуре',
      lowerInStructure: 'Ниже по структуре',
      joined: 'Присоединился',
      country: 'Странна',
      email: 'Почта',
    },
    shared: {
      referralLink: 'Реферальная ссылка',
      decrease: 'Уменьшить',
      increase: 'Увеличить',
      linkCopied: 'Ссылка скопирована',
      no: 'Нет',
      connectGoogleAuthenticator: 'Подключите Google Autentificator',
      valueOfMax: '{{value}} из {{max}}',
    },
    apiErrors: {
      generic: 'Не удалось выполнить действие. Попробуйте ещё раз.',
      server: 'Внутренняя ошибка сервера. Попробуйте позже.',
      unavailable: 'Сервис временно недоступен. Попробуйте позже.',
      network: 'Нет связи с сервером. Проверьте интернет-соединение.',
      secure: 'Не удалось установить защищённое соединение. Обновите страницу.',
      weak: 'Слабое соединение. Попробуйте ещё раз.',
      tooLarge: 'Слишком большой объём данных.',
      tooMany: 'Слишком частые запросы. Подождите минуту.',
      banned: 'Доступ временно ограничен из-за большого числа запросов. Попробуйте через {{seconds}} сек.',
      newVersion: 'Доступна новая версия личного кабинета. Страница будет обновлена.',
      loginRequired: 'Войдите в аккаунт.',
      sessionEnded: 'Сессия завершена. Войдите снова.',
      sessionExpired: 'Время сессии истекло. Войдите снова.',
      accessCheckFailed:
        'Не удалось подтвердить доступ к аккаунту. Войдите снова. Если вход не удаётся, обратитесь в поддержку.',
      validation: 'Проверьте введённые данные.',
      loginExpired: 'Время на вход истекло. Введите логин и пароль заново.',
      registry: {
        account: {
          progressUnavailable: 'Данные о прогрессе пока недоступны.',
          statisticsUnavailable: 'Статистика пока недоступна.',
        },
        common: {
          wrongConfirmationCode: 'Неверный код подтверждения. Введите логин и пароль заново и запросите новый код.',
          actionRefresh: 'Не удалось выполнить действие. Обновите страницу.',
        },
        validation: {
          required: 'Обязательное поле',
          invalidFormat: 'Недопустимые символы или формат',
          tooShort: 'Слишком короткое значение',
          tooLong: 'Слишком длинное значение',
          invalid: 'Недопустимое значение',
          integer: 'Введите целое число',
          number: 'Введите число',
          belowMinimum: 'Значение меньше допустимого',
          aboveMaximum: 'Значение больше допустимого',
          selectFromList: 'Выберите значение из списка',
        },
        auth: {
          enterCredentials: 'Введите логин и пароль',
          securityUnavailable: 'Не удалось загрузить настройки безопасности аккаунта. Обратитесь в поддержку.',
          startFailed: 'Не удалось начать вход. Попробуйте ещё раз.',
          continueFailed: 'Не удалось продолжить вход. Попробуйте ещё раз или обратитесь в поддержку.',
          sendCodeFailed: 'Не удалось отправить код. Попробуйте ещё раз.',
          sendSmsFailed: 'Не удалось отправить SMS с кодом. Попробуйте ещё раз.',
          completeFailed: 'Не удалось завершить вход. Попробуйте ещё раз.',
          signInFailed: 'Не удалось войти. Обратитесь в поддержку.',
          codeResent:
            'Код отправлен повторно. Для входа будет действовать пароль, указанный при первой попытке регистрации.',
          emailOrLoginTaken: 'Email или логин уже заняты',
          weakPassword:
            'Слишком простой пароль. Используйте хотя бы два типа символов: цифры, заглавные и строчные буквы, спецсимволы.',
          referralNotFound: 'Реферальный код не найден',
          registrationFailed: 'Не удалось зарегистрироваться. Попробуйте позже.',
          invalidEmail: 'Неверный email',
          invalidEmailOrCode: 'Неверный email или код. Если аккаунт уже подтверждён — войдите.',
          confirmEmailFailed: 'Не удалось подтвердить email. Попробуйте позже.',
          emailConfirmed: 'Email подтверждён. Войдите в аккаунт.',
          expiredEmailCode: 'Неверный email или код. Если прошло больше 5 минут, запросите код заново.',
          sendConfirmationFailed: 'Не удалось отправить код подтверждения. Попробуйте позже.',
          methodUnavailable: 'Этот способ подтверждения не подключён. Выберите другой.',
          invalidOrExpiredCode: 'Неверный или просроченный код',
          accountUnconfirmed: 'Аккаунт не подтверждён',
          userNotFound: 'Пользователь не найден',
          confirmEmailToSignIn: 'Подтвердите email, чтобы войти',
        },
        cart: {
          empty: 'Корзина пуста.',
          insufficientFunds: 'Недостаточно средств на балансе. Пополните баланс, чтобы оплатить заказ.',
          partialActivation:
            'Оплата прошла, но часть продуктов не активирована. Активируйте их в разделе купленных продуктов или обратитесь в поддержку.',
          manualDisabled: 'Оплата переводом на кошелёк отключена.',
          paymentAssetUnavailable: 'Выбранная сеть или монета недоступны. Выберите другую.',
          coinsbuyDisabled: 'Оплата через Coinsbuy отключена.',
          coinsbuyUnavailable: 'Оплата через Coinsbuy временно недоступна. Выберите другой способ.',
          coinsbuyCreateFailed: 'Не удалось создать платёж в Coinsbuy, попробуйте позже.',
          paymentCreateFailed: 'Не удалось создать платёж. Попробуйте позже или выберите другой способ.',
          invoiceUnavailable: 'Счёт не найден или уже обработан.',
          emptyFile: 'Файл пуст. Выберите другой файл.',
          fileTooLarge: 'Файл слишком большой. Попробуйте загрузить его файлом.',
          tariffUnavailable: 'Тариф недоступен. Обновите список тарифов.',
          currentTariffUnknown: 'Не удалось определить текущий тариф сервера. Обратитесь в поддержку.',
          upgradeInCart: 'Апгрейд этого сервера уже в корзине. Чтобы выбрать другой тариф, удалите его из корзины.',
          productUnavailable: 'Продукт больше недоступен.',
          addFailed: 'Не удалось добавить товар в корзину. Попробуйте ещё раз.',
          itemRemoved: 'Товар уже удалён из корзины.',
          duplicateRows: 'У товара несколько строк в корзине. Обновите корзину и выберите нужную строку.',
          quantityFailed: 'Не удалось изменить количество. Попробуйте ещё раз.',
          subscriptionQuantity: 'Подписка покупается одной штукой. Чтобы изменить срок, удалите её и добавьте заново.',
          renewalQuantity: 'Для продления меняйте срок в месяцах, а не количество.',
          minSignalsMonths: 'Минимальный срок подписки на сигналы — 3 мес.',
          renewalTermInvalid: 'Недопустимый срок продления вместе с улучшением тарифа.',
          minAmount: 'Минимальная сумма покупки {{amount}} $.',
        },
        confirmation: {
          settingsUnavailable: 'Не удалось получить настройки безопасности. Обновите страницу.',
          addPhoneFirst: 'Сначала добавьте номер телефона в профиле.',
          phoneCodeFailed: 'Не удалось отправить код. Возможно, защита по телефону уже включена — обновите страницу.',
          requestNewCode: 'Неверный или просроченный код. Запросите новый.',
          disablePhoneFailed: 'Не удалось отключить защиту по телефону. Обновите страницу.',
          connectGoogleFailed:
            'Не удалось подключить Google Authenticator. Возможно, он уже подключён — обновите страницу.',
          googleCodeInvalid:
            'Неверный код. Убедитесь, что время на телефоне установлено автоматически, и введите новый код.',
          disableGoogleFailed: 'Не удалось отключить Google Authenticator. Обновите страницу.',
          googleNotConnected: 'Google Authenticator не подключён.',
          invalidCode: 'Неверный код',
          telegramOtherAccount: 'К Вашему аккаунту уже привязан другой телеграм id.',
          telegramConnected: 'Telegram уже привязан.',
          telegramIdUsed: 'Данный телеграм id уже зарегистрирован.',
          telegramConnectFailed: 'Не удалось привязать Telegram. Попробуйте позже.',
          telegramBonusFailed: 'Telegram привязан, но бонус не начислен. Обратитесь в поддержку.',
          telegramAuthFailed: 'Не удалось авторизоваться в Telegram. Попробуйте ещё раз.',
          telegramAuthCancelled: 'Авторизация в Telegram отменена.',
        },
        content: {
          eventNotFound: 'Событие не найдено.',
          newsNotFound: 'Новость не найдена.',
          supportSectionNotFound: 'Раздел не найден.',
          supportArticleNotFound: 'Статья не найдена.',
        },
        finance: {
          historyUnavailable: 'Не удалось загрузить историю операций.',
          cancelFailed: 'Не удалось отменить операцию. Обновите историю: статус мог измениться.',
          balanceUnavailable: 'Не удалось загрузить баланс.',
          walletAndNetwork: 'Укажите кошелёк и сеть',
          minimumAmount: 'Сумма — целое число не меньше 30',
          withdrawalFailed: 'Не удалось создать заявку на вывод. Попробуйте позже.',
          withdrawalUnavailable: 'Не удалось создать заявку: недостаточно средств или выбранная сеть недоступна.',
        },
        partner: {
          structureUnavailable: 'Не удалось загрузить структуру.',
          referralUnavailable: 'Реферальная ссылка недоступна.',
          academyLoadFailed: 'Не удалось загрузить данные академии.',
          academyUnavailable: 'Данные академии недоступны.',
          profileUnavailable: 'Профиль партнёра недоступен.',
          purchasesForbidden: 'Нет доступа к покупкам этого партнёра.',
          materialNotFound: 'Материал не найден.',
        },
        products: {
          activationFailed: 'Не удалось активировать продукт. Попробуйте ещё раз или обратитесь в поддержку.',
          transferFailed: 'Не удалось передать продукт. Проверьте, что партнёр в вашей структуре.',
        },
        profile: {
          dataUnavailable: 'Не удалось загрузить данные. Обновите страницу.',
          deleteFailed: 'Не удалось удалить аккаунт. Попробуйте позже.',
          alreadyDeleted: 'Аккаунт уже удалён.',
          passwordSessionExpired: 'Не удалось сменить пароль. Войдите снова и повторите.',
          passwordInvalid:
            'Неверный текущий пароль, или новый пароль слишком простой либо содержит недопустимые символы (? , . : _).',
          passwordFailed: 'Не удалось сменить пароль. Попробуйте позже.',
          profileUnavailable: 'Не удалось загрузить профиль. Обновите страницу.',
          phoneProtected: 'Данные сохранены. Телефон нельзя изменить, пока включена защита по телефону.',
          saveFailed: 'Не удалось сохранить изменения. Попробуйте ещё раз.',
          photosTooLarge: 'Фото слишком большие. Уменьшите размер и попробуйте снова.',
          documentsFailed: 'Не удалось отправить документы. Возможно, заявка уже на проверке или верификация пройдена.',
          verificationUnavailable: 'Не удалось получить статус верификации.',
          securityUnavailable: 'Не удалось получить настройки безопасности.',
          linksUnavailable: 'Не удалось загрузить ссылки.',
          addLinkFailed: 'Не удалось добавить ссылку.',
          linkNotSaved: 'Ссылка не найдена или не сохранена. Список обновлён.',
        },
        servers: {
          provisioningFailed: 'Ошибка выдачи сервера. Обратитесь в поддержку.',
          tariffDiscontinued: 'Тариф больше не продаётся. Обратитесь в поддержку.',
          renewalFailed: 'Не удалось продлить сервер. Попробуйте ещё раз.',
          passwordFailed: 'Не удалось сменить пароль. Попробуйте позже.',
          newPasswordFailed: 'Не удалось получить новый пароль. Попробуйте позже или обратитесь в поддержку.',
          passwordNotSaved: 'Пароль сервера мог измениться, но не сохранился. Обратитесь в поддержку.',
          insufficientRenewalFunds: 'Недостаточно средств: для продления нужно {{price}}. Пополните баланс.',
        },
      },
    },
    security: {
      chooseConfirmationMethod: 'Выберите способ подтверждения',
      confirmationMethod: 'Способ подтверждения',
      choose: 'Выбрать',
      resendAfter: 'Отправить повторно через {{seconds}} с',
      confirmation: 'Подтверждение',
      protectAccount: 'Для защиты аккаунта выполните следующую проверку',
      authenticationCode: 'Код аутентификации',
      codeSentToEmail: 'Введите код, который мы отправили вам на почту',
      enterCode: 'Введите код',
      invalidCode: 'Неверный код подтверждения',
      resendWithSeconds: 'Отправить повторно ({{seconds}} сек.)',
      resend: 'Отправить повторно',
      changeConfirmationMethod: 'Изменить способ подтверждения',
      confirm: 'Подтвердить',
    },
  },
};

export default ru;
